export const organizationOnboardingTranslations = {
  fr: {
    requestAccount: {
      controlledAccess: "Accès contrôlé",
      title: "Demander un accès",
      intro:
        "Choisissez le type de compte. Les demandes Client sont envoyées à l’administrateur de l’organisation choisie, tandis que les demandes Administrateur sont traitées par le Super Admin.",
      accountType: "Type de compte",
      clientAccount: "Compte Client",
      clientHelp: "Rejoindre une organisation existante",
      adminAccount: "Compte Administrateur",
      adminHelp:
        "Après validation, vous recevrez un email pour créer votre organisation, votre mot de passe et déposer votre modèle PDF.",
      selectOrganization: "Organisation à rejoindre",
      loadingOrganizations: "Chargement des organisations...",
      chooseOrganization: "Choisir une organisation",
      clientApprovalInfo:
        "L’administrateur de cette organisation recevra et traitera votre demande.",
      newOrganization: "Nom de la nouvelle organisation",
      superAdminApprovalInfo:
        "Le Super Admin examinera cette demande. Après approbation, un email sécurisé vous permettra de créer l’organisation et son modèle PDF.",
      successClient:
        "Votre demande Client a été envoyée à l’administrateur de l’organisation sélectionnée.",
      successAdmin:
        "Votre demande Administrateur a été envoyée au Super Admin de la plateforme.",
    },
    adminRequests: {
      platformScope: "Demandes Administrateur",
      organizationScope: "Demandes Client de mon organisation",
      superAdminHint:
        "Le Super Admin voit et traite uniquement les demandes Administrateur. L’approbation envoie un lien sécurisé de création d’organisation.",
      orgAdminHint:
        "Vous voyez et traitez uniquement les demandes Client destinées à votre organisation.",
      approveAdminConfirm:
        "Approuver cette demande Administrateur et envoyer l’email de création d’organisation ?",
      approveClientConfirm:
        "Approuver cette demande Client et envoyer l’invitation de création de compte ?",
      approveAdminSuccess:
        "Demande Administrateur approuvée. L’email de création d’organisation a été envoyé.",
      approveClientSuccess:
        "Demande Client approuvée. L’invitation de création de compte a été envoyée.",
    },
    organizationSetup: {
      checking: "Vérification de l’invitation...",
      badge: "Invitation administrateur vérifiée",
      heroTitle: "Créez votre environnement CertiLink",
      heroText:
        "Définissez votre mot de passe, confirmez votre organisation et déposez le modèle PDF vierge qui servira à ses certificats.",
      secureInvitation: "Lien d’invitation sécurisé",
      isolatedWorkspace: "Espace et données isolés",
      oneOfficialTemplate: "Un modèle PDF officiel pour l’organisation",
      formEyebrow: "Création de l’organisation",
      formTitle: "Finaliser votre environnement",
      formText:
        "Configurez votre organisation, vos codes de sécurité et son modèle PDF officiel.",
      adminIdentity: "Identité de l’administrateur",
      adminName: "Nom complet",
      email: "Adresse email",
      lockedEmail: "Adresse vérifiée et non modifiable",
      organization: "Organisation",
      organizationName: "Nom de l’organisation",
      slug: "Identifiant de l’organisation",
      slugHint: "Utilisé dans les références internes et les URLs futures.",
      defaultLanguage: "Langue par défaut",
      french: "Français",
      english: "Anglais",
      password: "Mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      passwordHint:
        "8 caractères minimum, avec une majuscule, une minuscule et un chiffre.",
      securityCodes: "Codes personnels de sécurité",
      securityCodesHelp:
        "Choisissez deux codes différents. Le code d’accès est demandé à chaque connexion administrateur. Le code de suppression protège les actions destructives.",
      accessCode: "Code d’accès personnel",
      confirmAccessCode: "Confirmer le code d’accès",
      deletionCode: "Code personnel de suppression",
      confirmDeletionCode: "Confirmer le code de suppression",
      securityCodesNotice:
        "Ces codes sont propres à votre compte administrateur et sont enregistrés de manière chiffrée.",
      securityCodeLength: "Chaque code doit contenir entre 6 et 64 caractères.",
      accessCodeMismatch: "Les deux codes d’accès ne correspondent pas.",
      deletionCodeMismatch: "Les deux codes de suppression ne correspondent pas.",
      codesMustDiffer: "Le code d’accès et le code de suppression doivent être différents.",
      templateSection: "Modèle de certificat",
      templateLabel: "PDF vierge de l’organisation",
      templateHelp:
        "PDF obligatoire, 15 Mo maximum. Il sera le modèle unique de cette organisation. CB4C conserve ses quatre modèles actuels.",
      choosePdf: "Choisir le PDF vierge",
      pdfReady: "PDF prêt à être enregistré",
      create: "Créer mon organisation",
      creating: "Création en cours...",
      success: "Organisation créée avec succès. Redirection vers la connexion...",
      passwordMismatch: "Les deux mots de passe ne correspondent pas.",
      invalidPassword: "Le mot de passe ne respecte pas les critères de sécurité.",
      pdfRequired: "Veuillez sélectionner un fichier PDF vierge.",
      invalidPdf: "Le fichier sélectionné doit être un PDF.",
      pdfTooLarge: "Le fichier PDF ne doit pas dépasser 15 Mo.",
      invitationError: "Invitation invalide, expirée ou déjà utilisée.",
      setupError: "Impossible de créer l’organisation.",
    },
    templatePolicy: {
      organizationModel: "Modèle officiel de l’organisation",
      organizationModelDescription:
        "Ce modèle PDF unique a été déposé lors de la création de l’organisation.",
      cb4cModels: "Modèles CB4C",
      missingTemplate:
        "Aucun modèle PDF actif n’est configuré pour cette organisation.",
      loadingTemplate: "Chargement du modèle de certificat...",
      templateLoadError: "Impossible de charger le modèle de certificat.",
      model: "Modèle",
      allCertificatesSuccessful:
        "Pour cette organisation, chaque nouveau certificat est automatiquement enregistré comme réussite.",
      bulkAllSuccessfulColumns:
        "Colonnes conseillées : firstName, lastName et email. Tous les certificats seront enregistrés comme réussite.",
    },
  },
  en: {
    requestAccount: {
      controlledAccess: "Controlled access",
      title: "Request access",
      intro:
        "Choose the account type. Client requests are sent to the selected organization administrator, while Administrator requests are handled by the Super Admin.",
      accountType: "Account type",
      clientAccount: "Client account",
      clientHelp: "Join an existing organization",
      adminAccount: "Administrator account",
      adminHelp:
        "After approval, you will receive an email to create your organization, password and upload your PDF template.",
      selectOrganization: "Organization to join",
      loadingOrganizations: "Loading organizations...",
      chooseOrganization: "Choose an organization",
      clientApprovalInfo:
        "The administrator of this organization will receive and process your request.",
      newOrganization: "New organization name",
      superAdminApprovalInfo:
        "The Super Admin will review this request. After approval, a secure email will let you create the organization and its PDF template.",
      successClient:
        "Your Client request was sent to the administrator of the selected organization.",
      successAdmin:
        "Your Administrator request was sent to the platform Super Admin.",
    },
    adminRequests: {
      platformScope: "Administrator requests",
      organizationScope: "Client requests for my organization",
      superAdminHint:
        "The Super Admin sees and processes Administrator requests only. Approval sends a secure organization setup link.",
      orgAdminHint:
        "You see and process only Client requests addressed to your organization.",
      approveAdminConfirm:
        "Approve this Administrator request and send the organization setup email?",
      approveClientConfirm:
        "Approve this Client request and send the account creation invitation?",
      approveAdminSuccess:
        "Administrator request approved. The organization setup email was sent.",
      approveClientSuccess:
        "Client request approved. The account creation invitation was sent.",
    },
    organizationSetup: {
      checking: "Checking the invitation...",
      badge: "Administrator invitation verified",
      heroTitle: "Create your CertiLink workspace",
      heroText:
        "Set your password, confirm your organization and upload the blank PDF template that will be used for its certificates.",
      secureInvitation: "Secure invitation link",
      isolatedWorkspace: "Isolated workspace and data",
      oneOfficialTemplate: "One official PDF template for the organization",
      formEyebrow: "Organization creation",
      formTitle: "Complete your workspace",
      formText:
        "Configure your organization, security codes and official PDF template.",
      adminIdentity: "Administrator identity",
      adminName: "Full name",
      email: "Email address",
      lockedEmail: "Verified and not editable",
      organization: "Organization",
      organizationName: "Organization name",
      slug: "Organization identifier",
      slugHint: "Used for internal references and future URLs.",
      defaultLanguage: "Default language",
      french: "French",
      english: "English",
      password: "Password",
      confirmPassword: "Confirm password",
      passwordHint:
        "At least 8 characters, with one uppercase letter, one lowercase letter and one number.",
      securityCodes: "Personal security codes",
      securityCodesHelp:
        "Choose two different codes. The access code is required at every administrator sign-in. The deletion code protects destructive actions.",
      accessCode: "Personal access code",
      confirmAccessCode: "Confirm access code",
      deletionCode: "Personal deletion code",
      confirmDeletionCode: "Confirm deletion code",
      securityCodesNotice:
        "These codes belong to your administrator account and are stored as secure hashes.",
      securityCodeLength: "Each code must contain between 6 and 64 characters.",
      accessCodeMismatch: "The two access codes do not match.",
      deletionCodeMismatch: "The two deletion codes do not match.",
      codesMustDiffer: "The access code and deletion code must be different.",
      templateSection: "Certificate template",
      templateLabel: "Organization blank PDF",
      templateHelp:
        "PDF required, maximum 15 MB. It will be this organization's single template. CB4C keeps its four current templates.",
      choosePdf: "Choose the blank PDF",
      pdfReady: "PDF ready to be saved",
      create: "Create my organization",
      creating: "Creating...",
      success: "Organization created successfully. Redirecting to sign in...",
      passwordMismatch: "The two passwords do not match.",
      invalidPassword: "The password does not meet the security requirements.",
      pdfRequired: "Please select a blank PDF file.",
      invalidPdf: "The selected file must be a PDF.",
      pdfTooLarge: "The PDF file must not exceed 15 MB.",
      invitationError: "Invalid, expired or already used invitation.",
      setupError: "Unable to create the organization.",
    },
    templatePolicy: {
      organizationModel: "Organization official template",
      organizationModelDescription:
        "This single PDF template was uploaded when the organization was created.",
      cb4cModels: "CB4C templates",
      missingTemplate:
        "No active PDF template is configured for this organization.",
      loadingTemplate: "Loading the certificate template...",
      templateLoadError: "Unable to load the certificate template.",
      model: "Template",
      allCertificatesSuccessful:
        "For this organization, every new certificate is automatically recorded as successful.",
      bulkAllSuccessfulColumns:
        "Recommended columns: firstName, lastName and email. All certificates will be recorded as successful.",
    },
  },
};

export const getOrganizationTranslation = (lang, section, key, fallback = "") =>
  organizationOnboardingTranslations?.[lang === "en" ? "en" : "fr"]?.[section]?.[key] ||
  fallback;
